<template>
    <div id="roleGr">
        <table-coms
            v-if="data.tableList != undefined"
            :tableData="data.tableList.data"
            :cols="data.tableList.columns"
            :key="substr"
            :fixedNum="fixedNum"
            v-on:rederSub="GetrederSub"
            :checkboxFlag="true"
            v-on:selectRowData="getSelectDataTop"
            v-on:checkBoxSelectData="getBoxSelectData"
            :loading="parloading"
            ref="tablsUser"
            :setGmcuid="tableGmcuid"
            :subParAnsear="true"
            v-on:renderSearchVal="getredSearchVal"
            v-on:renderSortVal="getrenderSortVal"
            v-on:renderQueryVal="getrenderQueryVal"
            :TitleSearchVal="TitleSearchVal"
            :MaxHeight="MaxHeight"
        >
            <template slot="topFunction">
                <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;">
                    <div>
                        <a-row type="flex" justify="start">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Add') }}</span>
                                </template>
                                    <img @click="addEditRole('add')" class="sbxs mllr4" src="../../assets/img/ss-add.png"  width="22" height="22">
                                </a-tooltip
                            >
                            <a-popconfirm
                                :title="$t('pubGicSet.AreyoudeleTask')"
                                :okText="$t('pubGicSet.Yes')"
                                :cancelText="$t('pubGicSet.No')"
                                @confirm="deleteRole"
                            >
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>{{ $t('roleGe.Delete') }}</span>
                                    </template>
                                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                                </a-tooltip>
                            </a-popconfirm>
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>Refresh</span>
                                </template>
                                <img class="sbxs ml4" style="margin-top: 2px;" @click="handleToolClick" src="../../assets/img/ss-refresh.png" width="18" height="19">
                            </a-tooltip>

<!-- 
                                 <span style="float: left;margin-left: 6px;">
                                      <a-icon type="search" style="margin-right: 4px;"/>
                                         <a-select style="width: 180px" size="small" @change="skuTableTemplateData" v-model="parTableTemplateName" placeholder="Please select template">      
                                                     <a-select-option value="all">all</a-select-option>
                                                      <a-select-option
                                                              :key="item"
                                                              :value="item"
                                                              v-for="item in parTableTemplateSelect"
                                                      >{{ item }}</a-select-option>
                                     </a-select>
                               </span> -->


                        </a-row>
                    </div>
                    <div >
                        <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                            />
                    </div>
                </div>
            </template>
        </table-coms>
 <!-- :visible="DrawerVisible" -->
        <a-drawer
                :title="this.rightType == 'add' ? $t('roleGe.CreateRole') :  $t('roleGe.EditRole')"
                placement="right"
                :closable="true"
                :maskClosable="NomaskClosable"
                @close="onCloseDrawer"
                :visible="DrawerVisible"
                width="90%"
                :destroyOnClose="true"    
        >
            <a-tabs defaultActiveKey="1" >
                <a-tab-pane tab="Role" key="1">
                    <div style="overflow-y: auto;height: 70vh;margin-top: 20px;">
                        <a-spin :spinning="treeLoading">
                            <a-form :form="roleFormTop">
                                <a-row type="flex" justify="start">
                                    <a-col :span="8">
                                        <a-form-item :label="$t('roleGe.RoleName')" v-bind="formItemLayout">
                                            <a-input
                                                    size="small"
                                                    :placeholder="$t('roleGe.RoleName')"
                                                    style="width: 100%"
                                                    v-decorator="[
                                            'roleName',
                                            {
                                              initialValue: editObj.roleName,
                                              rules: [
                                                {
                                                  required: true,
                                                  message: $t('publicLang.Required')
                                                }
                                              ]
                                            }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item :label="$t('roleGe.RoleType')" v-bind="formItemLayout">
                                            <a-select
                                                    size="small"
                                                    allowClear
                                                    :placeholder="$t('roleGe.PleaseSelect')"
                                                    style="width: 100%"
                                                    v-decorator="[
                                        'roleType',
                                        {
                                          initialValue: editObj.roleType,
                                          rules: [
                                            {
                                              required: true,
                                              message: $t('publicLang.Required')
                                            }
                                          ]
                                        }
                                      ]">
                                                <a-select-option
                                                        v-for="(item, index) in roleTypeList"
                                                        :value="item.dataKey"
                                                        :key="index"
                                                >{{ item.dataValue }}</a-select-option
                                                >
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row type="flex" justify="start">
                                    <a-col :span="8">
                                        <a-form-item :label="$t('roleGe.Description')" v-bind="formItemLayout">
                                            <a-textarea
                                                    size="small"
                                                    :placeholder="$t('roleGe.Description')"
                                                    :rows="2"
                                                    style="width: 100%"
                                                    v-decorator="[
                                        'description',
                                        { initialValue: editObj.description }
                                      ]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item :label="$t('roleGe.RoleLevel')" v-bind="formItemLayout">

                                            <a-select
                                                size="small"
                                                allowClear
                                                :placeholder="$t('roleGe.PleaseSelect')"
                                                style="width: 100%"
                                                v-decorator="[
                                                    'roleLevel',
                                                    {
                                                      initialValue: editObj.roleLevel
                                                    }
                                                  ]">
                                                <a-select-option :key="0">Top</a-select-option>
                                                <a-select-option :key="1">High</a-select-option>
                                                <a-select-option :key="2">Meduim</a-select-option>
                                                <a-select-option :key="3">Low</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>
                            <a-directory-tree
                                    checkable
                                    @select="onSelect"
                                    :showIcon="false"
                                    :treeData="roleTreeList"
                                    v-model="checkedKeys"
                                    :checkedKeys="checkedKeys"
                            >
                            </a-directory-tree>
                        </a-spin>
                    </div>
                    <a-row type="flex" justify="end">
                        <a-col style="margin:4px">
                            <a-button type="primary" size="small" @click="saveRole">{{ $t('roleGe.Save') }}</a-button>
                        </a-col>
                    </a-row>
                </a-tab-pane>
                <a-tab-pane tab="User" key="2">
                    <a-row style="margin: 20px 0">
                        <img @click="addRoleUser" class="sbxs mr4" src="../../assets/img/ss-add.png"  width="22" height="22">
                        <a-popconfirm
                            :title="$t('pubGicSet.AreyoudeleTask')"
                            :okText="$t('pubGicSet.Yes')"
                            :cancelText="$t('pubGicSet.No')"
                            @confirm="deleteRoleUser('OG')"
                        >

                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('userlang.Delete') }}</span>
                                </template>
                                <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                            </a-tooltip>
                        </a-popconfirm>
                    </a-row>
                    <vxe-table
                            stripe
                            highlight-hover-row
                            border
                            resizable
                            size="mini"
                            ref="roleUerTableRef"
                            class="vxe-table-antd"
                            :data="roleUerData"
                            max-height="500"
                    >
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="loginAccount" title="Login Account"></vxe-table-column>
                        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dispName" title="Display Name"></vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
            </a-tabs>
        </a-drawer>


        <a-modal title="User" v-model="addUserVis" width="50%">

            <a-form :form="formQuery">
                <!--<div class="queryParam">
                   <a-form-item  class="genericFrom" label="Login Account:">
                        <a-input ref="loginAccount" style="width: 20%" size="small"  v-decorator="['loginAccount']" @pressEnter="queryUserInfo"/>
                    </a-form-item>
                    <a-form-item class="genericFrom"  label="Display Name:">
                        <a-input ref="dispName"  size="small"   v-decorator="['dispName']" @pressEnter="queryUserInfo" />
                    </a-form-item>
                </div>-->
                <a-row>
                    <a-col :span = "6" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>Login Account:</b>
                            <a-input size="small" v-decorator="['loginAccount']" @pressEnter="queryUserInfo"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span = "6" offset="1">
                        <a-form-item class="genericFrom">
                            <b>Display Name:</b>
                            <a-input size="small" v-decorator="['dispName']" @pressEnter="queryUserInfo"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="1" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>&nbsp; </b>
                            <a-button  type="primary" @click="queryUserInfo">Query</a-button>
                        </a-form-item>
                    </a-col>
                    <a-col :span="1" offset="1">
                        <a-form-item  class="genericFrom">
                            <b> &nbsp;</b>
                            <a-button  type="primary" @click="resetUserInfo">Reset</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <template slot="footer">
                <a-button  type="primary" @click="saveAddUser">{{ $t('userlang.Save') }}</a-button>
            </template>
            <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    size="mini"
                    :data="addUserTable"
                    ref="orgUserTableRef"
                    max-height="250"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
                </template>
                <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="loginAccount" title="Login Account"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dispName" title="Display Name"></vxe-table-column>

            </vxe-table>
        </a-modal>

    </div>
</template>
<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import tableComs from "../com/tableComs.vue";
    import cookie from '../../api/cookie';

    export default{
        components:{
            tableComs
        },
        data(){
            return{
//                uaer
                roleUerData: [],
                addUserVis: false,
                addUserTable: [],
//                分页
                pageSizeOptions:['10', '20', '30', '40','100','500','1000'],
                pagingTotal: 50,
                currentVal: 1,
                pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                parloading: true,
                MaxHeight: 350,
                substr: 0,
                fixedNum: 0,
//                弹窗
                DrawerVisible: false,
                NomaskClosable: false,
                parTableTemplateSelect:[],
                parTableTemplateName:null,
//                table
                data: {},
                tableGmcuid: '',
                editRoleUid: '',
                tableSelectBox: [], // table checkbox
                TitleSearchVal: [],
                pageInfoType: '',
                initRenderFnSearchParamsArr: {
                    SortValArr: [],
                    titleSearchArr: [],
                    andvanSearchArr: {}
                },
//                弹窗
                formItemLayout: {
                    labelCol: {
                        xs: { span: 8 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 8 },
                        sm: { span: 16 }
                    }
                },
                roleFormTop: this.$form.createForm(this),
                treeLoading: false,
                roleTreeList: [],
                checkedKeys: [],
                roleTypeList: [],
                editObj: {},
                rightType: '',
                formQuery: this.$form.createForm(this),
            }
        },
        created() {
            this.initData()
            this.MaxHeight = document.body.clientHeight - 160;
        },
        computed: {
            ...mapState(["lang"])
        },
        $route() {
            this.initData();
        },
        methods:{
            queryUserInfo(){
                this.formQuery.validateFields((err, val) => {
                    if (!err) {

                        let parasm = {};
                        parasm = val;
                        parasm.roleUid = this.editRoleUid

                        ajax.get(api.USERUNAUTHUASER, parasm).then(res => {
                            this.addUserTable = res.data
                        });
                    }
                });

            },
            resetUserInfo(){
                this.formQuery.resetFields();
                this.queryUserInfo();
            },
            cleardata(){
                this.data = []
                this.initData();
            },
            handleToolClick(){
                this.parTableTemplateName  = 'all'
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFnSearchParamsArr.titleSearchArr = [];
                this.initRenderFn('all');
            },
//            添加user
            addRoleUser(){
                this.formQuery.resetFields();
                this.addUserVis = true
                ajax.get(api.USERUNAUTHUASER,
                    {
                        roleUid:this.editRoleUid,
                        loginAccount:'',
                        dispName:''
                    }).then(res=>{
                    this.addUserTable = res.data
                })
            },
            saveAddUser(){
                let params = {
                    userUids: [],
                    roleUid: this.editRoleUid
                };
                let selectRecords = this.$refs.orgUserTableRef.getCheckboxRecords()
                if(selectRecords.length > 0) {
                    selectRecords.forEach(value => {
                        params.userUids.push(value.uid);
                    });
                    ajax.post(api.USERROLE, params).then(res => {
                        if (res.code == 200) {
                            this.addUserVis = false
                            ajax.get(api.USERROLUUID,{roleUid: this.editRoleUid}).then(res=>{
                                this.roleUerData = res.data
                            })
                        }
                    })
                }else{
                    this.$customMessage.error(this.$t('userlang.PleaseOneleast'));
                    return
                }
            },
            deleteRoleUser(){
                let userTable = this.$refs.roleUerTableRef.getCheckboxRecords()
                if (userTable.length < 1) {
                    this.$customMessage.warning(this.$t('userlang.PleaseOneleast'))
                    return;
                }
                let checkuid = [];
                userTable.forEach(value => {
                    checkuid.push(value.uid);
                });
                let params = {
                    userUids: checkuid,
                    roleUid: this.editRoleUid
                }
                ajax.post(api.USERREMOVEROLE, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        ajax.get(api.USERROLUUID,{roleUid: this.editRoleUid}).then(res=>{
                            this.roleUerData = res.data
                        })
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });
            },

//            table 功能
            GetrederSub(val){
                this.fixedNum = val;
                this.substr = this.substr + 1;
            },
            getSelectDataTop(val){
                this.DrawerVisible = true
                this.editRoleUid = val.uid
                this.addEditRole('edit')

//                user data
                ajax.get(api.USERROLUUID,{roleUid: this.editRoleUid}).then(res=>{
                    this.roleUerData = res.data
                })
            },
            getBoxSelectData(val){
                this.tableSelectBox = val
            },
            // getredSearchVal(val){
            //     let scParams = [];
            //     val.forEach((v, i) => {
            //         if (v.serVal) {
            //             scParams.push({ key: v.uid, value: v.serVal });
            //         }
            //     });
            //     this.TitleSearchVal = val;
            //     this.pageInfoType = "tle";
            //     this.currentVal = 1;
            //     this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
            //     this.initRenderFn();
            // },
           getredSearchVal(val) {
                this.TitleSearchVal = val;
                let scParams = [];
                let tt = JSON.parse(JSON.stringify(val))
                tt.forEach((v, i) => {
                    if(v.type == "Datetime"){
                        if(v.serVal){
                            v.serVal = moment(v.serVal).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    if (v.type == "Date") {
                        if(v.serVal){
                            v.serVal =  moment(v.serVal).format('YYYY-MM-DD')
                        }
                    }
                    if (v.serVal) {
                        if( Array.isArray(v.serVal)){
                            for(let i in v.serVal){
                                scParams.push({ key: v.uid, value: v.serVal[i] });
                            }
                        }else{
                            scParams.push({ key: v.uid, value: v.serVal });

                        }
                    }
                });
                this.pageInfoType = "tle";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
                this.initRenderFn();
            },
            getTemplateName(){
                ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.tableGmcuid }).then(res => {
                    this.parTableTemplateSelect = res.data

                });
            },

            skuTableTemplateData(val){
                this.clearImportUids();
                 this.parTableTemplateName  = val
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },


            getrenderSortVal(paramsArr){
                this.pageInfoType = "sort";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.SortValArr = paramsArr;
                this.initRenderFn();
            },
            getrenderQueryVal(item) {
                this.parloading = true;
                let jsonArray = item.query;
                jsonArray.gmcUid = this.tableGmcuid;
                let templateName  = item.tml
                if(templateName != undefined && templateName != null){
                  this.parTableTemplateName  = templateName 
                }                
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },

          initRenderFn() {
                this.$nextTick(()=>{
                    this.parloading = true;
                    let params = {
                        functionUid: this.$route.query.funcUid,
                        gmcUid: this.tableGmcuid,
                        language: this.lang,
                        userUid: this.$route.query.userUid,
                        paging: {
                            pageNum: this.currentVal,
                            pageSize: this.pagingSize
                        }
                    };

                    if (this.pageInfoType == "sort") {
                        params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
                    } else if (this.pageInfoType == "tle") {
                        params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
                    } else if (this.pageInfoType == "qf") {
                        params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
                        params.userSqlDto.template = this.parTableTemplateName
                    }
                    ajax.post(api.SKUS, params).then(res => {

                    if (res.code == 200) {
                        this.data = res.data;
                        // if (this.TitleSearchVal.length > 0) {
                        //     this.data.tableList.columns = this.TitleSearchVal;
                        // }
                        this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        this.substr = this.substr + 1;
                    } else {
                        this.$customMessage.error(res.msg, 5);
                    }

                    });
                })
            },

            // initRenderFn(){
            //     this.parloading = true;
            //     let params = {
            //         functionUid: this.$route.query.funcUid,
            //         gmcUid: this.tableGmcuid,
            //         language: this.lang,
            //         userUid: this.$route.query.userUid,
            //         paging: {
            //             pageNum: this.currentVal,
            //             pageSize: this.pagingSize
            //         }
            //     };
            //     if (this.pageInfoType == "sort") {
            //         params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
            //     } else if (this.pageInfoType == "tle") {
            //         params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
            //     } else if (this.pageInfoType == "qf") {
            //         params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
            //         params.userSqlDto.template = this.parTableTemplateName
            //     }
            //     ajax.post(api.SKUS, params).then(res=>{
            //         this.parloading = false
            //         this.tableSelectBox = []
        
            //         if (res.code == 200) {
            //             this.data = res.data;
            //             if (this.TitleSearchVal.length > 0) {
            //                 this.data.tableList.columns = this.TitleSearchVal;
            //             }
            //             this.pagingTotal = res.data.tableList.paging.totalPageSize;
            //             this.substr = this.substr + 1;
            //         } else {
            //             this.$customMessage.error(res.msg, 5);
            //         }
            //     })
            // },
            initData(type){
                this.currentVal = 1;
                let params = {
                    userUid: this.$route.query.userUid,
                    functionUid: this.$route.query.funcUid,
                    language: this.lang,
                    pageNum: this.currentVal,
                    pageSize: this.pagingSize
                };

                // if( "empty_temp" != type ){
                //         let templateName = this.parTableTemplateName;
                //         if(templateName == null || templateName == undefined){
                //              this.parTableTemplateName = type
                //             templateName = type;
                //         }
                //          this.pageInfoType = "qf"
                //          params.userSqlDto = {};
                //          params.userSqlDto.template = templateName
                // }else{
                //         this.parTableTemplateName = undefined
                // }

                this.funApi = this.$route.query.funApi
                ajax.get(this.funApi, params).then(res=>{
                    if(res.code == 200){
                        this.parloading = false
                        this.substr = this.substr + 1
                        this.data = res.data
                        this.tableGmcuid = res.data.gmcUid

                        this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        this.pagingSize = res.data.tableList.paging.pageSize;
                    }else {
                        this.data = [];
                        this.$customMessage.error(res.msg);
                    }
                })
            },





            
//            分页
         tableChangePage(current){
                this.currentVal = current;
                this.initRenderFn();
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;            
                 this.initRenderFn();
            },
            onCheck(checkedKeys) {
                this.checkedKeys = checkedKeys;
            },
            onSelect(selectedKeys) {
                this.selectedKeys = selectedKeys;
            },
            deleteRole(){
                if (this.tableSelectBox.length < 1) {
                    this.$customMessage.warning(this.$t('roleGe.pleaseOneOnly'));
                    return;
                }
                let checkuid = [];
                this.tableSelectBox.forEach(value => {
                    checkuid.push(value.uid);
                });
                let params = {
                    roleUids: checkuid
                };
                ajax.post(api.DELETEROLE, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.roleRowKeys = [];
                        this.initRenderFn();
                    }else{
                         this.$customMessage.warning(res.msg);
                    }
                });
            },
            saveRole() {
                this.roleFormTop.validateFields((err, val) => {
                    if (!err) {
                        this.treeLoading = true
                        let getArr = this.checkedKeys;
                        let paramsArr = [];
                        for (let index in getArr) {
                            if (isNaN(getArr[index])) {
                                paramsArr.push(getArr[index]);
                            }
                        }
                        let parasm = {};
                        if (this.rightType == "add") {
                            parasm = val;
                        } else if (this.rightType == "edit") {
                            parasm = val;
                            parasm.uid = this.editRoleUid
                        }
                        parasm.functionList = getArr;
                        ajax.post(api.ROLE, parasm).then(res => {
                            this.treeLoading = false
                            if (res.code == 200) {
                                this.$message.success(res.msg)
                                if(this.rightType == "add"){
                                     this.onCloseDrawer();
                                      this.initRenderFn();
                                }   
                            }else{
                                this.$customMessage.warning(  res.msg);
                                return
                            }
                        });
                    }
                });
            },
            addEditRole(type) {
                this.roleFormTop.resetFields();
                this.DrawerVisible = true
                this.editObj = {}
                this.treeLoading = true
                if (type == "add") {
                    ajax.get(api.TYPEANDPERM).then(res => {
                        this.roleTypeList = res.data.roleTypeList;
                        this.roleTreeList = res.data.treeList;
                        this.dataFilterData(this.roleTreeList);
                        this.treeLoading = false
                    });
                    this.rightType = 'add'
                }
                else if (type == "edit") {
                    let params = {
                        uid: this.editRoleUid
                    };
                    ajax.get(api.FINDONE, params).then(res => {
                        this.editObj = res.data;
                        this.roleTypeList = res.data.list;
                    });
                    ajax.get(api.USERPERMISSION, {
                            userUid: "",
                            roleUid: this.editRoleUid
                        })
                        .then(res => {
                            this.treeLoading = false
                            this.roleTreeList = res.data;
                            this.dataFilterData(res.data);
                        });
                    this.rightType = 'edit'
                }
            },
            onCloseDrawer(){
                 this.DrawerVisible = false
                 this.roleUerData = []
            },
            dataFilterData(data) {
                let checkTree = [];
                for (let i in data) {
                    let aaa = data[i].children;
                    for (let iii in aaa) {
                        let ttt = aaa[iii].children;
                        if(ttt.length == 0 && aaa[iii].checked){
                            checkTree.push(aaa[iii].key);
                        }
                        for (let iii in ttt) {
                            if (ttt[iii].checked) {
                                checkTree.push(ttt[iii].key);
                            }
                            let hh = ttt[iii].children;
                            for (let it in hh){
                                if (hh[it].checked) {
                                    checkTree.push(hh[it].key);
                                }
                            }
                        }
                    }
                }
                this.checkedKeys = checkTree;
            },
        }
    }
</script>
<style>
    .queryParam{
        float: top;
        margin: 5px 10px;
    }
 </style>